import React, { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import useLogout from 'utils/hooks/useLogout';
import { useBaoSelector } from 'utils/hooks/redux';
import {
  ADMIN,
  GOOGLE_SALES_REP,
  isAnyAdmin,
  SALES_REP,
  SUPER_ADMIN,
} from 'utils/constants/roles';
import { useWindowDimensions } from 'pages/AuthPage/AuthPage';
import { neutrals } from 'utils/styles/color';

import CompanySwitch from 'molecules/CompanySwitch';
// import Circle from 'utils/styles/Circle.styles';
import {
  Stack,
  Container,
  Link,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Grow,
  MenuItem,
  Divider,
} from '@mui/material';

import {
  StyledHeader,
  MenuWrapper,
  MobileWrapper,
  StyledIconButton,
  StyledMenuList,
  StyledHeaderContent,
  StyledLogoText,
  StyledLogoContainer,
  StyledHeaderMenu,
} from './Header.styles';
import Logo from 'utils/styles/Logo.styles';
import { ReactComponent as LogoutIcon } from 'assets/icons/logout.svg';
import { ReactComponent as PaymentsOutlinedIcon } from 'assets/icons/payment-settings.svg';
import { ReactComponent as AccountsOutlinedIcon } from 'assets/icons/account-settings.svg';
import { ReactComponent as SettingsIcon } from 'assets/icons/menu-settings.svg';
import { ReactComponent as MenuIcon } from 'assets/icons/humburger.svg';
import { ReactComponent as LogIcon } from 'assets/icons/logs.svg';
import { palette } from 'utils/styles/variables';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { NewBadge } from 'molecules/NewBadge';
import axios from 'axios';
import { UserCompany } from 'store/user/userSlice';
import { TENANT_MENU_ITEMS, TENANT_ROUTES } from 'tenants/features';
import { useTenant } from 'tenants/TenantProvider';
import { getRuntimeTenantPortalUrl } from 'tenants/tenantConfigService';
// import { IReportParams, ReportData } from 'organisms/CloudOpsReport/types';

const Header = () => {
  const location = useLocation();

  const [open, setOpen] = React.useState(false);
  const [activeCompanies, setActiveCompanies] = React.useState<UserCompany[]>(
    []
  );
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const logout = useLogout();
  const { width } = useWindowDimensions();
  const { value: user } = useBaoSelector((state) => state.user);
  const { branding, isMenuItemVisible, isRouteVisible, tenantKey } =
    useTenant();
  const shouldShowReportsBadge = tenantKey !== 'aquazeel';
  //   const { currentCompany } = useBaoSelector((state) => state.common);
  //   const hsId = currentCompany?.company_hs_id
  //     ? String(currentCompany?.company_hs_id)
  //     : null;

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const outsideClick = (event: MouseEvent) => {
    if (
      event.target instanceof Node &&
      !anchorRef.current?.contains(event.target) &&
      open
    ) {
      setOpen(false);
    }
  };
  useEffect(() => {
    // Timeout is needed to make sure that the user is logged in
    setTimeout(() => {
      axios
        .get(`${process.env.REACT_APP_USER_SERVICE}/me`)
        .then(({ data }) => {
          setActiveCompanies(
            data.company?.filter((company: UserCompany) => !company.deactivated)
          );
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.error(err);
          if (!user.companies?.length) return [];
          setActiveCompanies(
            user.companies.filter((company) => !company.deactivated)
          );
          return [];
        });
    }, 100);
  }, []);

  useEffect(() => {
    window.addEventListener('mousedown', outsideClick);

    return () => window.removeEventListener('mousedown', outsideClick);
  });

  const isSuperAdmin = user.userType === SUPER_ADMIN;
  const isAdmin = user.userType === ADMIN;
  const isSalesRep = user.userType === SALES_REP;
  const isGoogleSalesRep = user.userType === GOOGLE_SALES_REP;

  const dashboardPage = location.pathname.startsWith('/dashboard');
  const invoicesPage = location.pathname.startsWith('/invoices');
  const companiesPage = location.pathname.startsWith('/companies');
  const contactsPage = location.pathname.startsWith('/contacts');
  const coreportsPage = location.pathname.startsWith('/coreports');
  const settingsPage = location.pathname.startsWith('/settings');
  const accountPage = location.pathname.startsWith('/account');
  const paymentPage = location.pathname.startsWith('/payment');
  const logsPage = location.pathname.startsWith('/logs');
  const projectsPage = location.pathname.startsWith('/projects');
  const helpCenterPage = location.pathname.startsWith('/help-center');

  // useEffect(() => {
  //   if (isSuperAdmin || isAdmin) return; // no need to fetch payment methods for admins
  //   if (!currentCompany) return; // if no company selected no need to fetch payment methods
  //   if (user && user.userType && user.accessToken !== '') {
  //     setTimeout(() => {
  //       fetchPaymentMethods({ currentCompany, customer: true }).then(
  //         (response) => {
  //           const mainPaymentMethod = response.find((p: PMethod) => p.isMain);
  //           if (
  //             response.length === 2 &&
  //             !mainPaymentMethod &&
  //             !location.pathname.startsWith('/payment')
  //           ) {
  //             window.location.href = `${window.location.origin}/payment`;
  //           }
  //         }
  //       );
  //     }, 500);
  //   }
  // }, [user?.userType, hsId]);

  //   useEffect(() => {
  //     fetchCustomerReports();
  //   }, [user?.userType, hsId]);

  //   const fetchCustomerReports = async () => {
  //     if (!hsId) return;

  //     try {
  //       const params: IReportParams = {
  //         company_hs_id: hsId,
  //         limit: 1,
  //         page: 1,
  //       };

  //       const { data } = await axios.get<ReportData>(
  //         `${process.env.REACT_APP_USER_SERVICE}/projects/reports`,
  //         { params }
  //       );

  //       setReportCount(data.count);
  //     } catch (getReportError) {
  //       // eslint-disable-next-line
  //       console.log('Failed to get report count: ', getReportError);
  //     }
  //   };

  const isCompanySwitch = (() => {
    if (isAnyAdmin(user?.userType)) return false;
    return activeCompanies && activeCompanies.length > 1;
  })();

  const showReportsPage = (() =>
    isAnyAdmin(user?.userType) ||
    user?.userType === GOOGLE_SALES_REP ||
    user?.userType === 'company_admin')();

  const showDashboardMenuItem = isMenuItemVisible(TENANT_MENU_ITEMS.dashboard);
  const showInvoicesMenuItem = isMenuItemVisible(TENANT_MENU_ITEMS.invoices);
  const showCompaniesMenuItem =
    (isSuperAdmin || isAdmin) &&
    isMenuItemVisible(TENANT_MENU_ITEMS.companies) &&
    isRouteVisible(TENANT_ROUTES.companies);
  const showContactsMenuItem =
    (isSuperAdmin || isAdmin) &&
    isMenuItemVisible(TENANT_MENU_ITEMS.contacts) &&
    isRouteVisible(TENANT_ROUTES.contacts);
  const showProjectsMenuItem =
    (isSuperAdmin || isAdmin) &&
    isMenuItemVisible(TENANT_MENU_ITEMS.projects) &&
    isRouteVisible(TENANT_ROUTES.projects);
  const showReportsMenuItem =
    showReportsPage &&
    isMenuItemVisible(TENANT_MENU_ITEMS.reports) &&
    isRouteVisible(TENANT_ROUTES.reports);
  const showSettingsMenuItem =
    (isSuperAdmin || isAdmin) &&
    isMenuItemVisible(TENANT_MENU_ITEMS.settings) &&
    isRouteVisible(TENANT_ROUTES.settings);
  const showPaymentMenuItem =
    !isAnyAdmin(user?.userType) &&
    !isGoogleSalesRep &&
    isMenuItemVisible(TENANT_MENU_ITEMS.payment) &&
    isRouteVisible(TENANT_ROUTES.payment);
  const showLogsMenuItem =
    (isSuperAdmin || isAdmin) &&
    isMenuItemVisible(TENANT_MENU_ITEMS.logs) &&
    isRouteVisible(TENANT_ROUTES.logs);
  const showHelpCenterMenuItem =
    isMenuItemVisible(TENANT_MENU_ITEMS.helpCenter) &&
    isRouteVisible(TENANT_ROUTES.helpCenter);
  const showAccountMenuItem =
    isMenuItemVisible(TENANT_MENU_ITEMS.account) &&
    isRouteVisible(TENANT_ROUTES.account);

  return (
    <StyledHeader>
      <Container>
        <StyledHeaderContent>
          <Stack
            direction="row"
            alignItems="center"
            gap={width >= 600 ? '32px' : '16px'}
          >
            <StyledLogoContainer>
              <a
                href={getRuntimeTenantPortalUrl() || window.location.origin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Logo />
              </a>
              <StyledLogoText>{branding.appName}</StyledLogoText>
            </StyledLogoContainer>

            {isCompanySwitch && <CompanySwitch companies={activeCompanies} />}
          </Stack>
          <StyledHeaderMenu $admin={isAdmin || isSuperAdmin}>
            {!isSalesRep && !isGoogleSalesRep && showDashboardMenuItem && (
              <Link
                className={dashboardPage ? 'active' : ''}
                component={RouterLink}
                to="/dashboard"
              >
                Dashboard
              </Link>
            )}
            {!isGoogleSalesRep && showInvoicesMenuItem && (
              <Link
                className={invoicesPage ? 'active' : ''}
                component={RouterLink}
                to="/invoices"
              >
                Invoices
              </Link>
            )}
            {showCompaniesMenuItem && (
              <Link
                className={companiesPage ? 'active' : ''}
                component={RouterLink}
                to="/companies"
              >
                Companies
              </Link>
            )}
            {showContactsMenuItem && (
              <Link
                className={contactsPage ? 'active' : ''}
                component={RouterLink}
                to="/contacts"
              >
                Contacts
              </Link>
            )}
            {showProjectsMenuItem && (
              <Link
                className={projectsPage ? 'active' : ''}
                component={RouterLink}
                to="/projects"
              >
                Projects
              </Link>
            )}
            {showReportsMenuItem &&
              (shouldShowReportsBadge ? (
                <NewBadge offsetX={-6}>
                  <Link
                    className={coreportsPage ? 'active' : ''}
                    component={RouterLink}
                    to="/coreports"
                  >
                    Reports
                  </Link>
                </NewBadge>
              ) : (
                <Link
                  className={coreportsPage ? 'active' : ''}
                  component={RouterLink}
                  to="/coreports"
                >
                  Reports
                </Link>
              ))}
            {showHelpCenterMenuItem && (
              <Link
                className={helpCenterPage ? 'active' : ''}
                component={RouterLink}
                to="/help-center"
              >
                Help
              </Link>
            )}
            {/* Differently render Reports page */}
          </StyledHeaderMenu>
          <MenuWrapper>
            <StyledIconButton
              disableRipple
              aria-label="profile menu"
              id="menu-icon"
              ref={anchorRef}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              $fill={open ? palette.error.main : undefined}
            >
              <MenuIcon />
            </StyledIconButton>

            <Popper
              open={open}
              anchorEl={anchorRef.current}
              transition
              placement="bottom-end"
              style={{ zIndex: 10 }}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper sx={{ boxShadow: '0px 1px 3px 0px #999999' }}>
                    <StyledMenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      $isMobile={width < 600}
                    >
                      <MobileWrapper>
                        {!isSalesRep &&
                          !isGoogleSalesRep &&
                          showDashboardMenuItem && (
                            <MenuItem>
                              <Link component={RouterLink} to="/dashboard">
                                <ListItemText
                                  className={dashboardPage ? 'active' : ''}
                                >
                                  Dashboard
                                </ListItemText>
                              </Link>
                            </MenuItem>
                          )}
                        {!isGoogleSalesRep && showInvoicesMenuItem && (
                          <MenuItem>
                            <Link component={RouterLink} to="/invoices">
                              <ListItemText
                                className={invoicesPage ? 'active' : ''}
                              >
                                Invoices
                              </ListItemText>
                            </Link>
                          </MenuItem>
                        )}
                        {showCompaniesMenuItem && (
                          <MenuItem>
                            <Link component={RouterLink} to="/companies">
                              <ListItemText
                                className={companiesPage ? 'active' : ''}
                              >
                                Companies
                              </ListItemText>
                            </Link>
                          </MenuItem>
                        )}
                        {showContactsMenuItem && (
                          <MenuItem>
                            <Link component={RouterLink} to="/contacts">
                              <ListItemText
                                className={contactsPage ? 'active' : ''}
                              >
                                Contacts
                              </ListItemText>
                            </Link>
                          </MenuItem>
                        )}
                        {showProjectsMenuItem && (
                          <MenuItem>
                            <Link component={RouterLink} to="/projects">
                              <ListItemText
                                className={projectsPage ? 'active' : ''}
                              >
                                Projects
                              </ListItemText>
                            </Link>
                          </MenuItem>
                        )}
                        {showReportsMenuItem && (
                          <MenuItem>
                            <Link component={RouterLink} to="/coreports">
                              <ListItemText
                                className={coreportsPage ? 'active' : ''}
                              >
                                Reports
                              </ListItemText>
                            </Link>
                          </MenuItem>
                        )}
                        {showHelpCenterMenuItem && (
                          <MenuItem>
                            <Link component={RouterLink} to="/help-center">
                              <ListItemText
                                className={helpCenterPage ? 'active' : ''}
                              >
                                Help Center
                              </ListItemText>
                            </Link>
                          </MenuItem>
                        )}
                        {!isSuperAdmin && !isAdmin && (
                          <Divider
                            sx={{
                              borderBottomWidth: 1,
                              margin: '0 !important',
                            }}
                          />
                        )}
                      </MobileWrapper>
                      {showSettingsMenuItem && (
                        <MenuItem>
                          <Link component={RouterLink} to="/settings">
                            <ListItemIcon>
                              <SettingsIcon
                                color={
                                  settingsPage
                                    ? palette.error.main
                                    : neutrals[800]
                                }
                              />
                            </ListItemIcon>
                            <ListItemText
                              className={settingsPage ? 'active' : ''}
                            >
                              Settings
                            </ListItemText>
                          </Link>
                        </MenuItem>
                      )}
                      {showPaymentMenuItem && (
                        <MenuItem>
                          <Link component={RouterLink} to="/payment">
                            <ListItemIcon>
                              <PaymentsOutlinedIcon
                                color={
                                  paymentPage
                                    ? palette.error.main
                                    : neutrals[800]
                                }
                              />
                            </ListItemIcon>
                            <ListItemText
                              className={paymentPage ? 'active' : ''}
                            >
                              Payment settings
                            </ListItemText>
                          </Link>
                        </MenuItem>
                      )}
                      {showLogsMenuItem && (
                        <MenuItem>
                          <Link component={RouterLink} to="/logs">
                            <ListItemIcon>
                              <LogIcon
                                color={
                                  logsPage ? palette.error.main : neutrals[800]
                                }
                              />
                            </ListItemIcon>
                            <ListItemText className={logsPage ? 'active' : ''}>
                              Logs
                            </ListItemText>
                          </Link>
                        </MenuItem>
                      )}
                      {!isSalesRep && (
                        <Divider
                          sx={{ borderBottomWidth: 1, margin: '0 !important' }}
                        />
                      )}
                      {user?.name && (
                        <MenuItem disabled>
                          <ListItemText>
                            {user?.name} {user?.surname || ''}
                          </ListItemText>
                        </MenuItem>
                      )}
                      {showAccountMenuItem && (
                        <MenuItem sx={{ height: 36 }}>
                          <Link component={RouterLink} to="/account">
                            <ListItemIcon>
                              <AccountsOutlinedIcon
                                color={
                                  accountPage
                                    ? palette.error.main
                                    : neutrals[800]
                                }
                              />
                            </ListItemIcon>
                            <ListItemText
                              className={accountPage ? 'active' : ''}
                            >
                              Account Details
                            </ListItemText>
                          </Link>
                        </MenuItem>
                      )}
                      <MenuItem
                        component="a"
                        href={`mailto:${branding.supportEmail}`}
                        sx={{ height: 36 }}
                      >
                        <ListItemIcon>
                          <EmailOutlinedIcon
                            sx={{ color: neutrals[800], fontSize: 20 }}
                          />
                        </ListItemIcon>
                        <ListItemText>Contact us</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => logout()} sx={{ height: 36 }}>
                        <ListItemIcon>
                          <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText>Logout</ListItemText>
                      </MenuItem>
                    </StyledMenuList>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </MenuWrapper>
        </StyledHeaderContent>
      </Container>
    </StyledHeader>
  );
};

export default Header;
